export default __webpack_public_path__ + "static/media/github_icon.4cc7fa09.svg";